<template>
  <div
    class="mobile-promo-pill"
    data-testid="mobilePromoPill"
  >
    <AkParagraph size="sm">
      {{ content.description }}
    </AkParagraph>
    <div class="mobile-promo-pill__code">
      <AkParagraph
        weight="bold"
        class="mobile-promo-pill__label"
      >
        {{ content.action_label }}
      </AkParagraph>
      <AkButton
        class="mobile-promo-pill__copy"
        :class="{ 'mobile-promo-pill__copy--copied': isCopied }"
        :symbol="isCopied ? 'check2-circle' : 'copy-keyboard'"
        link
        size="md"
        data-testid="mobilePromoPillCopyBtn"
        @click.stop="copyCode"
      >
        {{ isCopied ? t('discoverySelection.copyButtonFeedback') : t('retailer.header.promoPill.copyButton') }}
      </AkButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { AkParagraph, AkButton } from '@ankorstore/design-system';
import type { HeaderPill } from '@monolith/legacy/types/api/pill';
import Analytics from '@monolith/legacy/services/analytics';
import UserClick from '@monolith/legacy/services/analytics/events/user-click.event';
import { SectionCreatedEvent } from '@monolith/legacy/services/analytics/events/section_created.event';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  content: HeaderPill;
}>();

const { t } = useI18n();
const isCopied = ref(false);

function copyCode(): void {
  navigator.clipboard.writeText(props.content.action_label ?? '');
  isCopied.value = true;

  setTimeout(() => {
    isCopied.value = false;
  }, 3000);

  Analytics.track(
    new UserClick({
      component: 'acquisition_offer_header_pill',
      action: 'copy_promocode',
      promocode: props.content.action_label,
    })
  );
}

onMounted(() => {
  Analytics.track(
    new SectionCreatedEvent({
      component: 'acquisition_offer_mobile_header_pill',
      action: 'display_promocode',
      value_proposition: 'display_acquisition_offer_mobile_header_pill_promocode',
      promocode: props.content.action_label,
    })
  );
});
</script>

<style lang="scss" scoped>
.mobile-promo-pill {
  @apply ds-bg-discount-100 ds-rounded-lg ds-flex ds-flex-col ds-gap-4 ds-p-6;
  padding: 24px;

  &__code {
    @apply ds-bg-white ds-p-2 ds-flex ds-justify-between ds-items-center ds-rounded-lg;
  }

  &__label {
    @apply ds-text-discount-700;
  }

  &__copy {
    &--copied {
      @apply ds-text-discount-700;
    }
  }
}
</style>
